module.exports = __webpack_public_path__ + "media/src/admin/images/mobile-clock-wallpaper-18df1783182a9641fa1f7a1a73abc64d.jpg";